import { NgModule } from '@angular/core';
import { CustomSmartEditFeatureModule } from '@smart-edit/feature';
import { provideConfig } from '@spartacus/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SmartEditRootModule } from '@spartacus/smartedit';

@NgModule({
  imports: [SmartEditRootModule, CustomSmartEditFeatureModule],
  providers: [
    provideConfig({
      featureModules: {
        smartEdit: {
          module: () => import('@spartacus/smartedit').then((m) => m.SpartacusSmarteditModule),
        },
      },
    }),
  ],
})
export class SmartEditFeatureModule {}
